"use strict";

import L from "leaflet";

/*
 * L.Control.Loading is a control that shows a loading indicator when tiles are
 * loading or when map-related AJAX requests are taking place.
 */

(function () {

    //var L = window.L;

    // https://github.com/ebrelsford/Leaflet.loading/blob/master/src/Control.Loading.js

    L.Control.Loading = L.Control.extend({

        options: {
            position: 'topright'
        },

        initialize: function(options) {
            L.setOptions(this, options);
            this._loading = false;
        },

        onAdd: function(map) {
            this._loader = $('<div>').addClass('leaflet-control-geoloader').hide();
            return this._loader[0];
        },

        onRemove: function(map) {},

        isLoading: function() {
            return this._loading;
        },

        showLoader: function() {
            this._loader.show();
            this._loading = true;
        },

        hideLoader: function() {
            this._loader.hide();
            this._loading = false;
        }

    });

    // adding init hooks

    L.Map.addInitHook(function () {
        this.loaderControl = new L.Control.Loading();
        this.addControl(this.loaderControl);
    });

    L.Control.loading = function(options) {
        return new L.Control.Loading(options);
    };

})();


// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/leaflet/leaflet-loader.js